import request from '@/router/axios';
const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'
const sysPrefix = '/sys';

/**
 * 导出列表数据 单级表头 excle
 * @param obj 参数
 * @param serv 指定访问服务的前缀
 */
export function exportTable(obj,serv) {
  return request({
    url:serv + '/refund/exportExcleAll',
    method: 'post',
    data: obj,
    responseType: 'arraybuffer',
  });
}/**
 * 导出列表数据 单级表头 excle
 * @param obj 参数
 * @param serv 指定访问服务的前缀
 */
export function exportSelectTable(obj,serv) {
  return request({
    url:serv + '/refund/export',
    method: 'post',
    data: obj,
    responseType: 'arraybuffer',
  });
}
// 导出列表表头
/**
 * 导出列表数据 多级表头 excle
 * @param obj 参数
 * @param serv 指定访问服务的前缀
 */
export function exportTableForHeaders(obj,serv) {
  return request({
    url: serv +'/refund/exportHeaders',
    method: 'POST',
    data: obj,
    responseType: 'arraybuffer',
  });
}


/**
 *  获取动态列头
 */
export function getdynamicTable(obj) {
  return request({
    url: urlPrefix +'/dynamicForm/getDynamicTable',
    method: 'POST',
    data:obj
  });
}

/**
 *  获取动态表单
 */
export function getDynamicForm(obj) {
  return request({
    url: urlPrefix +'/dynamicForm/getDynamicForm',
    method: 'POST',
    data: obj,
  });
}
/**
 *  获取动态页签
 */
 export  function  getDynamicTabs(obj) {
  return request({
    url: urlPrefix +'/tabs/tabsList',
    method: 'POST',
    data: obj
  });
}

/**
 * 态表单新增提交保存
 * @param obj 参数
 * @param serv 服务前缀
 * @constructor
 */
export function DynamicFormInsert(obj,serv) {
  return request({
    url: serv +'/dynaForm/ops/insert',
    method: 'POST',
    data: obj,
  });
}
/**
 *  动态表单修改提交保存
 * @param obj 参数
 * @param serv 服务前缀
 * @constructor
 */
export function DynamicFormUpdate(obj,serv) {
  return request({
    url: serv +'/dynaForm/ops/update',
    method: 'PUT',
    data: obj,
  });
}
/**
 *  获取自定义表头
 */
export function getCustomTableHeader(obj) {
  return request({
    url: urlPrefix +'/dynamicForm/customtableheader',
    method: 'post',
    data: obj,
  });
}


/**
 * 导出列表数据 多级表头 excle
 * @param obj 参数
 * @param serv 指定访问服务的前缀
 */
export function getCodeTreeByCodeSetId(obj) {
  return request({
    url: sysPrefix +'/syscodeitem/getcodetree/'+obj,
    method: 'get',
  });
}

// 下载模板
export function downloadExcleTmpl(obj) {
  return request({
    url: urlPrefix +'/excel/downloadtmpexcle',
    // method: 'get',
    responseType: 'arraybuffer',
    params: obj,
  });
}

//雇员下载精简模板
export function downloadEmpExcelTmpl(obj) {
  return request({
    url: urlPrefix +'/emp-excel/step1/downloadtmpexcelemp',
    // method: 'get',
    responseType: 'arraybuffer',
    params: obj,
  });
}

// 下载excle上传的错误信息
export function downloadErrorExcle(obj,serv) {
  return request({
    url: serv +'/exceldwnload/downloadError',
    // method: 'get',
    responseType: 'arraybuffer',
    params: obj,
  });
}

/**
 * 根据url 得到数据
 * @param obj 参数
 * @param serv 指定访问服务的前缀
 */
export   function getDataByUrl(url,obj) {
  return    request({
    url: url,
    method: 'get',
    params: obj,
  });
}

//客户下载精简模板
export function downloadCusExcelTmpl(obj) {
  return request({
    url: urlPrefix +'/cus-excel/step1/cus-template-download',
    responseType: 'arraybuffer',
    params: obj,
  });
}

//页面修改获取动态表格列表表头
export function getdynamicHeaderForUpdate(obj) {
  return request({
    url: urlPrefix +'/dynamicHeader/getFormHeader',
    method: 'POST',
    data:obj
  });
}

//页面修改获取动态表格列表表头
export function dynamicGetHeaderList(obj) {
  return request({
    url: urlPrefix +'/dynamicHeader/dynamicGetHeaderList',
    method: 'POST',
    data:obj
  });
}
